import { breakpoint, background, body, brand, spacing, text } from '@carvana/ds-styles';
import styled from 'styled-components';

const Background = styled.div`
  width: auto;
  background-color: ${background.strong};
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  justify-content: center;
  padding: 0 ${spacing['2Xl']};

  @media screen and (min-width: ${breakpoint.sm}) {
    padding: 0;
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    padding: 0 ${spacing['4Xl']};
  }
`;

const HeroContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${spacing['4Xl']} ${spacing['2Xl']};
  gap: ${spacing['2Xl']};

  @media screen and (min-width: ${breakpoint.sm}) {
    max-width: 959px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
    max-width: 1272px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${spacing['4Xl']};
  }
`;

const HeroFoldContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing['2Xl']};

  @media screen and (min-width: ${breakpoint.md}) {
    width: 100%;
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    align-items: unset;
  }
`;

const HeadingWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${breakpoint.lg}) {
    text-align: left;
    align-items: flex-start;
    flex: 1 0 0;
  }
`;

const Heading = styled.h2`
  ${brand.xs};
  text-transform: ${brand.sm.textCase};
  color: ${text.inverse};
  box-sizing: border-box;
  margin-top: 0;
  margin-bottom: 0;
  min-width: 327px;
  font-weight: 600;

  @media screen and (min-width: 375px) {
    ${brand.md};
  }

  @media screen and (min-width: ${breakpoint.md}) {
    ${brand.lg};
    font-weight: 900;
    text-align: left;
  }
`;

const SubTitle = styled.div`
  ${body.regular.md};
  box-sizing: border-box;
  color: ${text.inverse};

  @media screen and (min-width: ${breakpoint.md}) {
    ${body.regular.xl};
    max-width: 616px;
    text-align: left;
  }
`;

export { Background, Heading, HeroFoldContainer, SubTitle, HeroContainer, HeadingWrapper };
